class WarehouseInventoryItem {
    constructor(json) {
        if (json) {
            this.warehouseId = json.warehouseId;
            this.itemType = json.itemType;
            this.itemId = json.itemId;
            this.netQuantity = json.netQuantity;
            this.itemName = json.itemName;
            this.lowThreshold = json.lowThreshold;
            this.parentFolderId = json.parentFolderId;
        }
    }

    static TypeProduct = () => 'product';
    static TypeBundle = () => 'bundle';
    static TypeFolder = () => 'folder';
}

export default WarehouseInventoryItem;
